module.exports = __webpack_public_path__ + "static/img/73-1.2a436f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/73-1.jpg
// module id = q4Nx
// module chunks = 0